var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"z-button",class:( _obj = {}, _obj[("z-icon-" + _vm.position)] = true, _obj ),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon && !_vm.loading)?_c('z-icon',{attrs:{"name":_vm.icon}}):_vm._e(),(_vm.loading)?_c('z-icon',{staticClass:"loading",attrs:{"name":"loading"}}):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }